module.exports = __webpack_public_path__ + "img/logo.58a7b725.jpg";